// Used to catch outside clicks when tooltips or dropdowns are open
import { useCallback, useEffect, useRef } from 'react';
import { useVariable } from './useVariable';
import { refContainsTarget, refDefined, refParentContainsTarget } from '../helpers/refs';
export const useOutsideClick = (onClick, disabled = false, useParentNode = false, excludeRef) => {
  const parentRef = useRef(null);
  const childRef = useRef(null);
  const handleClick = useVariable(onClick);
  const handle = useCallback(e => {
    if (!refDefined(parentRef) || refContainsTarget(parentRef, e.target) || !refDefined(childRef) || refContainsTarget(childRef, e.target) || useParentNode && refParentContainsTarget(childRef, e.target) || excludeRef && refContainsTarget(excludeRef, e.target)) {
      // inside click of tooltip/dropdown or parent element
      return;
    }
    // outside click
    handleClick.current?.(e);
  }, []);
  useEffect(() => {
    if (disabled) {
      return;
    }
    document.addEventListener('touchstart', handle, {
      passive: true
    });
    document.addEventListener('mousedown', handle);
    return () => {
      document.removeEventListener('touchstart', handle);
      document.removeEventListener('mousedown', handle);
    };
  }, [disabled]);
  return {
    parentRef,
    childRef
  };
};